export default __webpack_public_path__ + "static/media/abhishek.ee9453bf.png";